const cards = [
  {
    title: '娱乐圈最新爆料汇总：本周不能错过的十大热点',
    desc: '娱乐圈风云再起，明星恋情、综艺争议、影视新作接连引爆话题。本周围绕多位一线艺人的最新动态，从片场路透到社交媒体互动，吃瓜群众关心的每一个细节都在这里，51吃瓜网入口为你一网打尽。',
    tag: '娱乐爆料',
    image: 'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20editorial%20illustration%20of%20entertainment%20news%20and%20celebrity%20gossip%20theme%2C%20overlapping%20magazine%20style%20collage%20elements%20with%20coral%20and%20gold%20accents%2C%20modern%20minimalist%20design%20with%20geometric%20patterns%2C%20clean%20composition%20with%20soft%20gradients%2C%20warm%20atmospheric%20lighting&width=800&height=560&seq=card-gossip-01&orientation=landscape',
  },
  {
    title: '综艺节目幕后揭秘：你所不知道的录制现场故事',
    desc: '热门综艺台前精彩纷呈，幕后同样看点十足。从选手真实关系、导师私下互动到节目组创意策划，我们深入挖掘综艺背后的精彩故事，带你看到一个更真实、更有趣的综艺世界。',
    tag: '综艺热议',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20stylized%20illustration%20of%20TV%20variety%20show%20behind%20the%20scenes%20theme%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20geometric%20stage%20lights%20and%20camera%20elements%2C%20modern%20editorial%20design%20with%20flowing%20shapes%2C%20soft%20atmospheric%20glow&width=800&height=560&seq=card-gossip-02&orientation=landscape',
  },
  {
    title: '网红圈新动向：头部主播最新动态与行业趋势分析',
    desc: '直播带货、短视频创作、内容电商——网红经济持续升温。从顶流主播的转型之路到新兴创作者的崛起故事，从行业数据到平台政策变化，51吃瓜网入口带你深度了解网红圈的最新动向。',
    tag: '网红动态',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20modern%20illustration%20of%20social%20media%20influencer%20and%20live%20streaming%20theme%2C%20warm%20peach%20and%20gold%20tones%2C%20geometric%20play%20button%20and%20notification%20bell%20motifs%2C%20clean%20editorial%20composition%20with%20curved%20shapes%2C%20soft%20gradient%20background&width=800&height=560&seq=card-gossip-03&orientation=landscape',
  },
  {
    title: '影视剧热播追踪：口碑爆款与争议之作全盘点',
    desc: '新剧上线、经典回归、电影定档——影视圈永远不缺话题。从收视率数据到观众真实口碑，从角色讨论到剧情分析，我们为你整理近期最值得关注的热播作品，不错过任何一部好剧。',
    tag: '影视追踪',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20film%20and%20TV%20drama%20tracking%20theme%2C%20warm%20coral%20red%20and%20soft%20gold%20palette%2C%20geometric%20film%20reel%20and%20clapperboard%20elements%2C%20clean%20modern%20composition%20with%20overlapping%20translucent%20shapes%2C%20cinematic%20atmosphere&width=800&height=560&seq=card-gossip-04&orientation=landscape',
  },
  {
    title: '社交媒体热帖精选：一周最火话题与神评论合集',
    desc: '微博热搜、抖音热门、小红书爆款——各大社交平台每天都在诞生新的话题。我们精选每周最受关注的帖子和评论区神回复，让你在最短时间内掌握全网热议焦点，吃瓜不再错过。',
    tag: '热帖精选',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20social%20media%20trending%20posts%20and%20viral%20topics%20theme%2C%20warm%20amber%20and%20soft%20peach%20tones%2C%20geometric%20speech%20bubbles%20and%20heart%20icons%2C%20modern%20minimalist%20editorial%20design%2C%20clean%20composition%20with%20flowing%20curves&width=800&height=560&seq=card-gossip-05&orientation=landscape',
  },
  {
    title: '明星穿搭街拍解析：当季最in时尚风向标',
    desc: '机场街拍、活动造型、私服穿搭——明星们的时尚选择总是引领潮流。从高定礼服到日常休闲，我们为你拆解明星穿搭背后的品牌故事和搭配技巧，让你轻松get同款时尚品味。',
    tag: '时尚解析',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20fashion%20editorial%20illustration%20with%20celebrity%20street%20style%20theme%2C%20warm%20coral%20and%20champagne%20gold%20palette%2C%20geometric%20fashion%20silhouettes%20and%20accessory%20elements%2C%20modern%20clean%20design%20with%20elegant%20flowing%20shapes%2C%20soft%20atmospheric%20lighting&width=800&height=560&seq=card-gossip-06&orientation=landscape',
  },
  {
    title: '音乐圈大事记：新歌发布、演唱会与行业动态一览',
    desc: '新专辑上线、演唱会官宣、音乐节阵容公布——音乐圈的好消息接连不断。从独立音乐人到顶流歌手，从数字专辑销量到巡演票房数据，51吃瓜网入口为你呈现音乐圈的最新动态与深度观察。',
    tag: '音乐动态',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20music%20industry%20news%20and%20concert%20theme%2C%20warm%20coral%20and%20golden%20amber%20palette%2C%20geometric%20music%20notes%20and%20sound%20wave%20elements%2C%20modern%20editorial%20design%20with%20rhythmic%20patterns%2C%20soft%20glowing%20atmosphere&width=800&height=560&seq=card-gossip-07&orientation=landscape',
  },
];

export default function CardsSection() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-3">热门吃瓜</h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
              精选全网最具话题性的吃瓜内容，每日更新，随时随地掌握最新娱乐动态与热门资讯
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {cards.slice(0, 6).map((card, idx) => (
              <a
                key={idx}
                href="#cards"
                onClick={(e) => handleNavClick(e, '#cards')}
                className="group block bg-background-100 rounded-lg overflow-hidden transition-colors hover:bg-background-200/70 cursor-pointer"
              >
                <div className="relative w-full aspect-[16/11] overflow-hidden bg-background-200">
                  <img
                    src={card.image}
                    alt={card.title}
                    title={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                      if (target.parentElement) {
                        target.parentElement.style.display = 'none';
                      }
                    }}
                  />
                </div>
                <div className="p-4 md:p-5">
                  <span className="inline-block px-2.5 py-1 rounded-md bg-primary-100 text-primary-700 text-xs font-medium mb-3">
                    {card.tag}
                  </span>
                  <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {card.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3">
                    {card.desc}
                  </p>
                </div>
              </a>
            ))}

            <a
              href="#cards"
              onClick={(e) => handleNavClick(e, '#cards')}
              className="group block bg-background-100 rounded-lg overflow-hidden transition-colors hover:bg-background-200/70 cursor-pointer sm:col-span-2 lg:col-span-3"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="relative w-full sm:w-2/5 aspect-[16/11] sm:aspect-auto overflow-hidden bg-background-200">
                  <img
                    src={cards[6].image}
                    alt={cards[6].title}
                    title={cards[6].title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                      if (target.parentElement) {
                        target.parentElement.style.display = 'none';
                      }
                    }}
                  />
                </div>
                <div className="p-4 md:p-6 flex-1 flex flex-col justify-center">
                  <span className="inline-block px-2.5 py-1 rounded-md bg-accent-100 text-accent-800 text-xs font-medium mb-3 w-fit">
                    {cards[6].tag}
                  </span>
                  <h3 className="font-heading text-lg md:text-xl text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                    {cards[6].title}
                  </h3>
                  <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
                    {cards[6].desc}
                  </p>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}